import { useEffect, useRef, useState } from "react";
import Reservationbg from "../../assets/images/Reserve-bg.svg";
import ReservationVideo from "./sections/ReservationVideo";
import SubscribeReservation from "./sections/SubscribeReservation";
import ReservationError from "./sections/ReservationError";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Reservation() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();
  const status = location.state?.status;
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);

  useEffect(() => {
    if (error || status === "error") {
      window.scrollTo({
        top: document.body.scrollHeight, // Scroll to the bottom of the page
        behavior: "smooth",
      });
    }
  }, [error, status]);

  const handleInputChange = (event) => {
    setEmail(event.target.value);
    setError("");
  };

  const divStyle = {
    backgroundImage: `url(${Reservationbg})`,
    backgroundSize: "cover", // or "contain" depending on your preference
    backgroundPosition: "top",
    width: "100%",
    height: "auto", // Adjust the height as needed
  };

  return (
    <>
      <Helmet>
        <title>Reservation - Leap</title>
        <meta
          name="description"
          content="Reserve your tour with Leap and make your experience unforgettable."
        />
      </Helmet>
      <div className="leap-pt-80 sm:leap-pt-72 md:leap-pt-56 lg:leap-pt-[10rem] xl:leap-pt-24 leap-bg-[#070322]"></div>
      <div style={divStyle}>
        <div>
          <div className="leap-text-center leap-absolute leap-top-40 leap-left-0 leap-right-0">
            <SubscribeReservation
              handleInputChange={handleInputChange}
              email={email}
              setEmail={setEmail}
              setIsInvalidEmail={setIsInvalidEmail}
              error={error}
              setError={setError}
            />
          </div>
        </div>
        <div className="leap-pb-10 leap-pt-60 sm:leap-pt-60 md:leap-pt-80 lg:leap-pt-[24rem] xl:leap-pt-[36rem]  2xl:leap-pt-[40rem] 3xl:leap-pt-[45rem] 4xl:leap-pt-[54rem] 5xl:leap-pt-[65rem]">
          {error || status === "error" ? (
            <ReservationError isInvalidEmail={isInvalidEmail} />
          ) : (
            <ReservationVideo />
          )}{" "}
        </div>
      </div>
    </>
  );
}

export default Reservation;
